export default __webpack_public_path__ + "static/media/korea-flag.ba51cb2e.png";